module.exports = __webpack_public_path__ + "img/Faixas-de-transito-.184c850f.png";